var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "div",
        { staticClass: "subTitle" },
        [
          _c(
            "el-link",
            {
              attrs: {
                icon: "el-icon-arrow-left",
                underline: false,
                href: "#/genericContents"
              }
            },
            [_vm._v("Content Management - Generic Contents")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "h3",
        {
          staticClass: "title",
          attrs: { content: "edit", placement: "bottom" }
        },
        [_vm._v("\n    Create Generic Contents\n    ")]
      ),
      _vm._v(" "),
      _c("generic-content-form", {
        attrs: { validate: _vm.triggerValidate },
        on: {
          setFormValue: function($event) {
            return _vm.getForm($event)
          },
          getIsValid: function($event) {
            return _vm.getIsValid($event)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "el-row",
        {
          staticStyle: { padding: "25px 0" },
          attrs: { type: "flex", justify: "end", gutter: 20 }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _vm.showSave
                ? _c(
                    "el-button",
                    {
                      staticClass: "reset",
                      staticStyle: { width: "100%" },
                      on: { click: _vm.handleCancel }
                    },
                    [_vm._v("Cancel")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _vm.showSave
                ? _c(
                    "el-button",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { type: "primary" },
                      on: { click: _vm.handleCreate }
                    },
                    [_vm._v("Create")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ad1d3ed6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad1d3ed6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/genericContent/genericContentCreate.vue
// module id = null
// module chunks = 